import React, { FC } from "react";
import Svg, { Path } from "react-native-svg";

import { useAppTheme } from "@/hooks/useAppTheme";
import { cn } from "@/utils/tailwind";

type VnLoadingSpinnerPropsType = {
  size?: number;
  className?: string;
  fill?: string;
};

export const VnLoadingSpinner: FC<VnLoadingSpinnerPropsType> = ({
  size = 20,
  className,
  fill,
}) => {
  const { resolvedColors } = useAppTheme();
  const pathFill = fill ?? resolvedColors.foreground;

  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={cn("animate-spin self-center", className)}
      accessibilityRole="image">
      <Path
        d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"
        opacity={0.25}
        fill={pathFill}
      />
      <Path
        d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z"
        fill={pathFill}
      />
    </Svg>
  );
};
